import { defineMessages } from 'react-intl';

export const integrationsNavItemMessages = defineMessages({
  label: {
    defaultMessage: 'Connectors',
    id: '2mMJRvsAg1',
  },
});
